import 'angular-xslt';

angular.module('TInv.XSLT', ['ngXslt']
).factory('XSLT', function ($q, $http, $filter, $sce, $window, $log) {
    function decodeUTF8(str) {
        // from http://stackoverflow.com/a/13691499/166524
        return $window.decodeURIComponent($window.escape(str));
    }
    var cache = { 'null': 'null' },
        xmlEncoding = /^[^<]{0,4}<[?]xml[^?]+encoding="([^"]+)"[^?]*[?]>/; // allow up to 4 characters of BOM in the beginning
    return {
        transform: function (xslt, xml) {
            if (!(xslt in cache))
                cache[xslt] = $http.get('style/' + xslt).then(function (resp) { return resp.data; });
            return $q.all({
                xslt: cache[xslt],
                xml: xml
            }).then(function (resp) {
                var xmlStr = (typeof resp.xml == 'string') ? resp.xml : $window.atob(resp.xml.Contenuto.toString()),
                    encoding = xmlEncoding.exec(xmlStr);
                $log.debug('XML encoding:', encoding && encoding[1]);
                xmlStr = xmlStr.replace('"http://www.fatturapa.gov.it/sdi/fatturapa/v1.1"',
                    '"http://ivaservizi.agenziaentrate.gov.it/docs/xsd/fatture/v1.2"');
                if (!encoding || (encoding[1].toUpperCase() == 'UTF-8'))
                    try {
                        xmlStr = decodeUTF8(xmlStr);
                        if (xmlStr.charCodeAt(0) == 0xFEFF) // strip UTF-8 BOM as the XML parser chokes on it
                            xmlStr = xmlStr.slice(1);
                    } catch (e) {
                        throw new Error('Invalid UTF-8 content in XML.');
                    }
                // else assume it is Latin1 or something similar enough (like CP1252)
                if (resp.xslt === 'null')
                    return [ '', xmlStr ];
                var html = $filter('xslt')(xmlStr, resp.xslt);
                html = $sce.trustAsHtml(html); // assuming we trust the XSLT, we trust the generated output
                return [ html, xmlStr ];
            });
        },
    };
});
